// extracted by mini-css-extract-plugin
export var badge = "_gt-2";
export var detailsPanel = "_gt-0";
export var resultRow = "_gt-1";